export class Controller {

    /** @ngInject */
    constructor($q) {
        this.$q = $q;
    }

    $onInit() {
    }

    cancel() {
        this.isEditing = false;
    }

    edit() {
        this.$value = this.initialValue;
        this.isEditing = true;
    }

    save() {
        this.isSaving = true;
        this.$q
            .resolve(this.onSave({$value: this.$value}))
            .finally(() => this.isEditing = this.isSaving = false)
    }

    notModified() {
        return this.$value === this.initialValue;
    }

    onKeyUp($event, form) {
        if ($event.keyCode === 13) {
            form.$valid && !this.notModified() && this.save();
        } else if ($event.keyCode === 27) {
            this.cancel();
        }
    }
}



// WEBPACK FOOTER //
// ./src/portal/components/sp-editable-label/sp-editable-label.controller.js